function Privacy() {
  return (
    <div className="container mx-auto my-8 px-4">
      <h2 className="text-4xl font-bold mb-6 text-slate-800">
        Datenschutzerklärung
      </h2>

      <div className="prose max-w-4xl text-slate-700">
        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            1. Datenschutz auf einen Blick
          </h3>

          <h4 className="text-xl font-semibold mb-3 text-slate-800">
            Allgemeine Hinweise
          </h4>
          <p className="mb-4">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was
            mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
            besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
            persönlich identifiziert werden können.
          </p>

          <h4 className="text-xl font-semibold mb-3 text-slate-800">
            Datenerfassung auf dieser Website
          </h4>
          <p className="mb-4">
            Die Datenverarbeitung auf dieser Website erfolgt durch den
            Websitebetreiber. Die Kontaktdaten können Sie dem Impressum dieser
            Website entnehmen.
          </p>

          <h5 className="text-lg font-semibold mb-2">
            Wie erfassen wir Ihre Daten?
          </h5>
          <p className="mb-4">
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
            mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in
            ein Kontaktformular eingeben.
          </p>

          <h5 className="text-lg font-semibold mb-2">
            Wofür nutzen wir Ihre Daten?
          </h5>
          <p className="mb-4">
            Die Daten werden erhoben, um eine fehlerfreie Bereitstellung der
            Website zu gewährleisten und um mit Ihnen zu kommunizieren, wenn Sie
            dies wünschen.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            2. Allgemeine Hinweise und Pflichtinformationen
          </h3>

          <h4 className="text-xl font-semibold mb-3 text-slate-800">
            Datenschutz
          </h4>
          <p className="mb-4">
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
            Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
            vertraulich und entsprechend der gesetzlichen
            Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            3. Kontaktformular und E-Mail-Kontakt
          </h3>
          <p className="mb-4">
            Wenn Sie uns per E-Mail kontaktieren, werden Ihre Angaben
            einschließlich der von Ihnen dort angegebenen Kontaktdaten zwecks
            Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns
            gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
            weiter.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            4. Analyse-Tools und Werbung
          </h3>
          <p className="mb-4">
            Diese Website verzichtet bewusst auf Analyse-Tools wie Google
            Analytics und auf Werbung. Es werden keine Tracking-Cookies gesetzt.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            5. Plugins und Tools
          </h3>
          <h4 className="text-xl font-semibold mb-3 text-slate-800">
            Google Maps
          </h4>
          <p className="mb-4">
            Diese Seite nutzt den Kartendienst Google Maps. Anbieter ist die
            Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
            Irland. Zur Nutzung der Google Maps-Funktionen ist es notwendig,
            Ihre IP-Adresse zu speichern. Diese Informationen werden in der
            Regel an einen Server von Google in den USA übertragen und dort
            gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese
            Datenübertragung. Die Nutzung von Google Maps erfolgt im Interesse
            einer ansprechenden Darstellung unserer Online-Angebote und an einer
            leichten Auffindbarkeit der von uns auf der Website angegebenen
            Orte.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            6. Ihre Rechte
          </h3>
          <p className="mb-4">Sie haben jederzeit das Recht:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>
              Auskunft über Ihre bei uns gespeicherten Daten zu erhalten
              (Artikel 15 DSGVO)
            </li>
            <li>
              Ihre bei uns gespeicherten Daten berichtigen zu lassen (Artikel 16
              DSGVO)
            </li>
            <li>
              Die Löschung Ihrer bei uns gespeicherten Daten zu verlangen
              (Artikel 17 DSGVO)
            </li>
            <li>
              Die Einschränkung der Datenverarbeitung zu verlangen (Artikel 18
              DSGVO)
            </li>
            <li>Einer Datenverarbeitung zu widersprechen (Artikel 21 DSGVO)</li>
            <li>Datenübertragbarkeit zu verlangen (Artikel 20 DSGVO)</li>
          </ul>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            7. SSL- bzw. TLS-Verschlüsselung
          </h3>
          <p className="mb-4">
            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
            Übertragung vertraulicher Inhalte eine SSL- bzw.
            TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
            daran, dass die Adresszeile des Browsers von "http://" auf
            "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            8. Speicherdauer
          </h3>
          <p className="mb-4">
            Wir speichern personenbezogene Daten nur solange, wie es für die
            Erfüllung der genannten Zwecke erforderlich ist oder gesetzliche
            Aufbewahrungsfristen dies vorschreiben. Nach Wegfall des
            Verarbeitungszwecks oder nach Ablauf dieser Fristen werden die
            entsprechenden Daten routinemäßig gelöscht.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            9. Verantwortliche Stelle
          </h3>
          <p className="mb-4">
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser
            Website ist:
          </p>
          <p className="mb-1">Lisa Fuchsen</p>
          <p className="mb-1">Dauner Straße 2</p>
          <p className="mb-1">54516 Wittlich</p>
          <p className="mb-4">E-Mail: stepintochange.withlisa@gmail.com</p>
          <p className="mb-4">
            Verantwortliche Stelle ist die natürliche oder juristische Person,
            die allein oder gemeinsam mit anderen über die Zwecke und Mittel der
            Verarbeitung von personenbezogenen Daten entscheidet.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Privacy;
